import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.less'
import './style/index.scss'
// import dayjs from 'dayjs'
// import 'dayjs/locale/zh-cn'

// dayjs.locale('zh-cn')
createApp(App).use(Antd).use(store).use(router).mount('#app')
